import { trim } from './string';

export const getLink = (
  slug: string,
  country: string,
  location?: string,
  hash?: string,
): string => {
  const trimmedSlug = trim(slug || '', '/');
  const path = `/${country}/${location ? location + '/' : ''}${
    trimmedSlug ? trimmedSlug + '/' : ''
  }`.replace(/\/+/g, '/');

  return `${path}${hash ? hash : ''}`;
};
